import React from "react";
import PropTypes from "prop-types";

import Form from "../../common/Form";
import Row from "../../common/Row";
import Table from "../../common/Table";
import { generateGuid } from "../../../util/guid";
import { Popup } from 'semantic-ui-react';
import Button from "../../common/Button";
import AutoComplete from "../../common/AutoComplete";

import * as types from "../../../constants/ComponentConstants";
import Section from "../../common/Section";
import { orderByPropertyName } from "../../../util/orderBy.js";
import { UserTypes } from "../../../constants/DomainConstants";

const NiveauInstantieForm = (props) => {
    const {
        models,
        options,
        onAddInstantie,
        onRemoveInstantie,
        onChange,
        onSave,
        onUndo,
        instantieToAdd,
        disabled,
        instantieToAddHasFocus,
        undoButtonDisabled,
        organisatieNiveau,
        userType,
        isNew
    } = props;

    function handleOnRemoveInstantie(i) {
        return function () {
            onRemoveInstantie(i);
        };
    }

    function returnTd(text, length) {
        return (
            <td>{text && text.length > length ? <Popup trigger={<p>{text.substring(0, length) + "..."}</p>} content={text} /> : text ? text : ""}</td>
        );
    }

    const tdStyle = { padding: "5px" };

    const instanties = orderByPropertyName(options.filter(o => models.indexOf(o.value) > -1), "label");

    const instantieRows = instanties.map((instantie, index) => {
        let item = models.find(x => x.toString() === instantie.value.toString());

        return (
            <tr key={index} style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' }}>
                {instantie ? returnTd(instantie.label, 60) : null}
                <td style={tdStyle}>
                    <span>
                        <Popup trigger={<span onClick={handleOnRemoveInstantie(item)} style={{ fontSize: '1rem', cursor: 'pointer' }}><i className="fa fa-remove fa-fw"></i></span>} content={"Verwijder gemeente die tot deze sportclub behoort"} />
                    </span>
                </td>
            </tr>
        );
    });

    return (
        <Section title="Gemeente waartoe de sportclub behoort" color={types.COLOR_TURQUOISE_DARK}>
            <Section>
                <Form name="niveauInstanties"
                    headerVisible={false}
                    isNotRequired
                    rightButtonLabel={!isNew ? "Bewaar" : null}
                    onRightButtonClick={onSave}
                    rightButtonDisabled={disabled}
                    onUndoButtonClick={onUndo}
                    undoButtonVisible={!undoButtonDisabled}
                >
                    {models && models.length ?
                        <Table
                            headers={["Gemeente waartoe de sportclub behoort"]}
                            headerSizes={[95, 5]}
                        >
                            {instantieRows}
                        </Table>
                        :
                        (isNew && userType === UserTypes.GEMEENTEMEDEWERKER)
                            ? <Section><p style={{ 'color': '#595959' }}>Je gemeente wordt hier toegevoegd.</p></Section>
                            : <Section><p style={{ 'color': '#595959' }}>Deze sportclub behoort nog niet tot een gemeente.</p></Section>
                    }
                    {!isNew ?
                        <Row>
                            <AutoComplete
                                value={instantieToAdd}
                                items={options.filter(x => x.niveauEnum === organisatieNiveau).sort(x => x.label)}
                                size={10}
                                onChange={onChange}
                                label=""
                                name="instantieToAdd"
                                clearable
                                key={generateGuid()}
                                minSearchLength={2}
                                hasFocus={instantieToAddHasFocus} />
                            <Button text="Voeg toe" onClick={onAddInstantie} className="o-col-2" disabled={instantieToAdd.length < 2} />
                        </Row>
                        : null}
                </Form >
            </Section>
        </Section >
    );
};

NiveauInstantieForm.propTypes = {
    models: PropTypes.array,
    options: PropTypes.array,
    onAddInstantie: PropTypes.func.isRequired,
    onRemoveInstantie: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onUndo: PropTypes.func,
    instantieToAdd: PropTypes.string,
    instantieToAddHasFocus: PropTypes.bool,
    organisatieNiveau: PropTypes.number,
    disabled: PropTypes.bool,
    undoButtonDisabled: PropTypes.bool,
    userType: PropTypes.string,
    gemeenteNaam: PropTypes.string,
    isNew: PropTypes.bool
};

export default NiveauInstantieForm;
